'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeCallParticipants = require('./KayleeCallParticipants');

var callProps = [
    'activeMeetingCode',
    'calendarEventId',
    'callExtendedState',
    'callInListId',
    'callState',
    'callType',
    'canControlLayout',
    'canDial',
    'canEndMeeting',
    'canInvite',
    'canRecordMeeting',
    'canSpotlight',
    'contactName',
    'defaultCallInCountryId',
    'dialPrefix',
    'dialString',
    'direction',
    'displayDialString',
    'end',
    'extraDialString',
    'isBeingRecorded',
    'layouts',
    'meetingCodes',
    'meetingPassword',
    'missed',
    'participantId',
    'receiveGain',
    'sendingContent',
    'sendingVideo',
    'start',
];
var KayleeCall = {
    addUpdatesToCreateCall: addUpdatesToCreateCall,
    addUpdatesToRemoveCall: addUpdatesToRemoveCall,
    callProps: callProps,
    fromJson: fromJson,
    getCall: getCall,
};

function addUpdatesToCreateCall(update, companyId, siteId, roomId, callId, info) {
    update['calls/' + callId] = {
        callState: info.callState,
        callType: info.callType,
        companyId: companyId,
        direction: info.direction,
        roomId: roomId,
        siteId: siteId,
    };

    callProps.forEach(function(prop) {
        if (typeof info[prop] !== 'undefined' && info[prop] !== null) {
            update['calls/' + callId][prop] = info[prop];
        }
    });

    update['index/callsByRoom/' + roomId + '/' + callId] = true;

    return Promise.resolve(update);
}

function addUpdatesToRemoveCall(update, roomId, callId) {
    update['calls/' + callId] = null;
    update['index/callsByRoom/' + roomId + '/' + callId] = null;
    return Promise.resolve(update);
}

function fromJson(data) {
    var reqProps = [ '$id' ];
    return FirebaseObject.$fromJson(data, 'Call', reqProps, reqProps,
        function(data) { return getCall(data.$id); }
    );
}

function getCall(callId) {
    var key = 'Call: ' + callId;
    var call = KayleeCache.get(key);

    if (call === null) {
        call = new Call(callId);
        KayleeCache.put(key, call);
    }

    return call;
}

function Call(callId) {
    this.$nodeType = 'call';
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('calls/' + callId));
}

Call.prototype = Object.create(FirebaseObject.prototype);
Call.prototype.constructor = Call;

Call.prototype.$defaults = {
    missed: false,
};

Call.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$id' ]);
};

Call.prototype.toString = function() {
    return '[Call ' + ' (' + this.$id + ')]';
};

Call.prototype.$getParticipants = function() {
    return KayleeCallParticipants.getCallParticipants(this.$id);
};

module.exports = KayleeCall;
